import { render, staticRenderFns } from "./reQuote.vue?vue&type=template&id=23860afc&scoped=true"
import script from "./reQuote.vue?vue&type=script&lang=js"
export * from "./reQuote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23860afc",
  null
  
)

export default component.exports